var map = {
	"./Valorant/Valorant": "H+b0",
	"./Valorant/Valorant.jsx": "H+b0",
	"./ValorantAccount/ValorantAccount": "n67P",
	"./ValorantAccount/ValorantAccount.jsx": "n67P",
	"./auth/ForgotPassword": "mKed",
	"./auth/ForgotPassword/": "mKed",
	"./auth/ForgotPassword/ForgotPassword": "w1tj",
	"./auth/ForgotPassword/ForgotPassword.tsx": "w1tj",
	"./auth/ForgotPassword/index": "mKed",
	"./auth/ForgotPassword/index.ts": "mKed",
	"./auth/Login": "a5ZW",
	"./auth/Login/": "a5ZW",
	"./auth/Login/Login": "trf0",
	"./auth/Login/Login.tsx": "trf0",
	"./auth/Login/index": "a5ZW",
	"./auth/Login/index.ts": "a5ZW",
	"./auth/Register": "RvkG",
	"./auth/Register/": "RvkG",
	"./auth/Register/Register": "pyA1",
	"./auth/Register/Register.tsx": "pyA1",
	"./auth/Register/index": "RvkG",
	"./auth/Register/index.ts": "RvkG",
	"./auth/ResetPassword": "h1XR",
	"./auth/ResetPassword/": "h1XR",
	"./auth/ResetPassword/ResetPassword": "TYy/",
	"./auth/ResetPassword/ResetPassword.tsx": "TYy/",
	"./auth/ResetPassword/index": "h1XR",
	"./auth/ResetPassword/index.ts": "h1XR",
	"./auth/VerifyEmail": "JSrK",
	"./auth/VerifyEmail/": "JSrK",
	"./auth/VerifyEmail/VerifyEmail": "e48z",
	"./auth/VerifyEmail/VerifyEmail.tsx": "e48z",
	"./auth/VerifyEmail/index": "JSrK",
	"./auth/VerifyEmail/index.ts": "JSrK",
	"./common/constants/accounts": "xKJ7",
	"./common/constants/accounts.tsx": "xKJ7",
	"./common/constants/skinsAndChampions": "SVoP",
	"./common/constants/skinsAndChampions.tsx": "SVoP",
	"./common/hooks": "iPac",
	"./common/hooks/": "iPac",
	"./common/hooks/index": "iPac",
	"./common/hooks/index.ts": "iPac",
	"./common/hooks/usePageProps": "b4JJ",
	"./common/hooks/usePageProps.ts": "b4JJ",
	"./common/hooks/useToggle": "ZN2p",
	"./common/hooks/useToggle.ts": "ZN2p",
	"./common/types/OrderItems": "N2By",
	"./common/types/OrderItems.ts": "N2By",
	"./common/types/RegionsAndRanks": "KUDj",
	"./common/types/RegionsAndRanks.ts": "KUDj",
	"./common/types/SkinsAndChampions": "abrh",
	"./common/types/SkinsAndChampions.ts": "abrh",
	"./common/types/User": "BP6N",
	"./common/types/User.ts": "BP6N",
	"./components/FlashMessage": "n2xx",
	"./components/FlashMessage.tsx": "n2xx",
	"./components/crousal/Button": "NZWW",
	"./components/crousal/Button.tsx": "NZWW",
	"./components/crousal/Headings": "6qhp",
	"./components/crousal/Headings.tsx": "6qhp",
	"./components/crousal/Label": "48zz",
	"./components/crousal/Label.tsx": "48zz",
	"./components/crousal/NumberInput": "DwKT",
	"./components/crousal/NumberInput.tsx": "DwKT",
	"./components/crousal/SelectInput": "OI1S",
	"./components/crousal/SelectInput.tsx": "OI1S",
	"./components/crousal/TextInput": "W+pB",
	"./components/crousal/TextInput.tsx": "W+pB",
	"./components/utils/url": "jzXk",
	"./components/utils/url.ts": "jzXk",
	"./customerDashboard/Dashboard": "MAHN",
	"./customerDashboard/Dashboard/": "MAHN",
	"./customerDashboard/Dashboard/Dashboard": "18y3",
	"./customerDashboard/Dashboard/Dashboard.tsx": "18y3",
	"./customerDashboard/Dashboard/Pagination": "TfaK",
	"./customerDashboard/Dashboard/Pagination.tsx": "TfaK",
	"./customerDashboard/Dashboard/dashboardPopup/Popup": "V1s+",
	"./customerDashboard/Dashboard/dashboardPopup/Popup.tsx": "V1s+",
	"./customerDashboard/Dashboard/dashboardPopup/popup.scss": "kdCn",
	"./customerDashboard/Dashboard/index": "MAHN",
	"./customerDashboard/Dashboard/index.ts": "MAHN",
	"./customerDashboard/Dashboard/steps/Step1": "HGGY",
	"./customerDashboard/Dashboard/steps/Step1.tsx": "HGGY",
	"./customerDashboard/Dashboard/steps/Step2": "UhOW",
	"./customerDashboard/Dashboard/steps/Step2.tsx": "UhOW",
	"./customerDashboard/Dashboard/steps/Step2b": "TtYF",
	"./customerDashboard/Dashboard/steps/Step2b.tsx": "TtYF",
	"./customerDashboard/Dashboard/steps/Step3": "IOgE",
	"./customerDashboard/Dashboard/steps/Step3.tsx": "IOgE",
	"./customerDashboard/Dashboard/steps/Step3b": "ULS/",
	"./customerDashboard/Dashboard/steps/Step3b.tsx": "ULS/",
	"./customerDashboard/Dashboard/steps/Step4": "c5Jm",
	"./customerDashboard/Dashboard/steps/Step4.tsx": "c5Jm",
	"./customerDashboard/Orders": "3FNN",
	"./customerDashboard/Orders/": "3FNN",
	"./customerDashboard/Orders/OrderItemsEmptyState": "7wiR",
	"./customerDashboard/Orders/OrderItemsEmptyState.tsx": "7wiR",
	"./customerDashboard/Orders/Orders": "HXSF",
	"./customerDashboard/Orders/Orders.tsx": "HXSF",
	"./customerDashboard/Orders/index": "3FNN",
	"./customerDashboard/Orders/index.ts": "3FNN"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bdSX";